import PropTypes from 'prop-types';
import React from 'react';

const GraphButton = ({ label, id, title, className, disabled, icon, ...rest }) => {
  // // debug-console.log('GraphButton: isDisabled, rest=', disabled, rest);
  return (
    // eslint-disable-next-line react/self-closing-comp
    <input
      id={id}
      value={label}
      title={title}
      className={`${className} btn btn-primary btn-submit`}
      type="submit"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      disabled={disabled}
      {...rest}
    ></input>
  );
};

GraphButton.defaultProps = {
  icon: null,
  id: '',
  className: '',
  label: '',
  title: '',
};

GraphButton.protoTypes = {
  icon: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
};
export default React.memo(GraphButton);
